export const environment = {
  production: false,
  apiUrl: 'https://dms-api-dev.cw.deltafaucet.com/api',
  aadClientId: '41067046-c41e-4dd5-8b3e-b8eed3224ab6',
  apiClientId: '67d062ea-c83a-46c0-bbd9-6e9748fb3ba0',
  aadAuthority: 'https://login.microsoftonline.com/a19f8d53-91d3-403c-9b6c-2033f5ab3b9e/',
};
